import React, { Component } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import styled from 'styled-components'
import './App.css'
import colors from './colors'
import ContentContainer from './ContentContainer'


const AppContainer = styled.div`
    border-top: 3px solid ${colors.text};
    padding-left: 12px;
    padding-right: 12px;
    @media print {
        border-top: none;
    }
`

class App extends Component {
    render() {
        return (
            <AppContainer>
                <Router>
                    <ContentContainer />
                </Router>
            </AppContainer>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js